import { Row, Col } from "react-bootstrap";
import Objective from "./Objective";
import "./ObjectivesList.css";

function ObjectivesList({ objectives, language }) {
  return (
    <Col className="objectives-list">
      <Row>
        {objectives.map((element) => (
          <Objective
            key={element._id}
            id={element._id}
            description={element.description}
            dueDate={element.dueDate}
            startDate={element.created_at}
            weight={element.weight}
            progress={element.progress}
            status={element.status}
            checkInStatus={element.checkInStatus}
            lastCheckInProgress={element.lastCheckInProgress}
            lastCheckInStatus={element.lastCheckInStatus}
            lastCheckInDate={element.lastCheckInDate}
            language={language}
          />
        ))}
      </Row>
    </Col>
  );
}

export default ObjectivesList;
